import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'



export const GetSOAReport = async (reqData) => {
    //debugger;
    //console.log(reqData)
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/GetSOAReport`, JSON.stringify(reqData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// export const GetInvoiceReport = async (reqData) => {
//     //debugger;
//     //console.log(reqData)
//     var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/GetInvoiceReport`, JSON.stringify(reqData), CommonVariables.API_HEADER)).then(response => response);
//     return result;
// }


export const GetInvoiceReport = async (reqData) => {
    //debugger;
    //console.log(reqData)
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/GetInvoiceDetailReportByClientCode`, JSON.stringify(reqData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetInvoiceReport_date = async (reqData) => {
    //debugger;
    //console.log(reqData)
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/GetInvoiceDetailReportByClientCode_date`, JSON.stringify(reqData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const ResendInvoice = async (reqData) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/ResendInvoice`, JSON.stringify(reqData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const GetMonthlySOAReport = async (reqData) => {
    //debugger;
    //console.log(reqData)
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/GetMonthlySOAReport`, JSON.stringify(reqData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}


// export const GetInvoiceDetailReportByClientCode = async (reqData) => {
//     //debugger;
//     //console.log(reqData)
//     var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/GetInvoiceDetailReportByClientCode`, JSON.stringify(reqData), CommonVariables.API_HEADER)).then(response => response);
//     return result;
// }
